// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useTheme } from "@mui/material/styles";
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import PropTypes from "prop-types";
import useTranslation from "next-translate/useTranslation";

import { Box, Breadcrumbs } from "@/components/core";
import { useShortcutMenuStore } from "@/store/shortcut-menu";
import { Navigations } from "./navigations";
import { initialData } from "./shortcuts-data";

export function Navbar({ sx, hideBreadcrumb }) {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const mobileMediaQuery = theme.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  const setShortcuts = useShortcutMenuStore((state) => state.setShortcuts);
  const setIsMounted = useShortcutMenuStore((state) => state.setIsMounted);

  useEffect(() => {
    const mappedData = initialData.map((sc) => ({ ...sc, name: t(`navbar.${sc.name}`) }));

    setShortcuts(mappedData);
    setIsMounted(true);
  }, []);

  return (
    <Box
      sx={{
        background: theme.palette.background.gradient,
        color: theme.palette.background.default,
        padding: { xs: 1, md: 2 },
        borderRadius: { xs: "0px", md: "0px 0px 20px 20px" },
        textAlign: "left",
        ...sx,
      }}
    >
      <Navigations />
      {!hideBreadcrumb && !isMobileDevice && <Breadcrumbs />}
    </Box>
  );
}

Navbar.propTypes = {
  sx: PropTypes.any,
  hideBreadcrumb: PropTypes.bool,
};
